import { FormattedMessage } from 'react-intl';
import React from 'react';
import { Layout } from 'antd';
import styled from 'styled-components';
const { Footer: AFooter } = Layout;

const StyledAFooter = styled(AFooter)`
  text-align: center;
  background-color: #D7753E;
  color: #fff;
`;

const Footer = () => {
  return (
    <StyledAFooter>
      <FormattedMessage id='footer.copyright'/>

      <div
        onClick={() => {
          window.displayPreferenceModal();
          return false;
        }} to='#' style={{ marginLeft: 2, textDecoration: 'underline' }}
      ><FormattedMessage id='footer.consent-preferences'/>
      </div>
      <a href='#' className='termly-display-preferences'><FormattedMessage id='footer.consent-preferences-link'/></a>
    </StyledAFooter>
  );
};
export default Footer;
